import styled from 'styled-components';
import { BasketPriceDetailsStyled } from '../../BasketPriceDetailsStyled';
import { rem } from 'polished';

export const BasketPriceDetailsOV = styled(BasketPriceDetailsStyled)`
    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h3};
        }
    }
`;
